export function QSubChartEnable() {
  this.fEnableSCWiz = false;
  this.fEnableInsertBreak = false;
  this.fEnableRemoveBreak = false;
}
